// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gimmighoul_roaming: PokeData = {
  "id": 10263,
  "name": "gimmighoul-roaming",
  "height": 1,
  "weight": 10,
  "base_experience": 60,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "tackle",
    "astonish"
  ],
  "moves": [
    "tackle",
    "shadow-ball",
    "shadow-dagger",
    "poltergeist",
    "soul-sacrifice",
    "spectral-snatch",
    "shadow-claws",
    "spectral-chain",
    "lick",
    "confuse-ray",
    "curse",
    "shadow-sneak",
    "night-shade"
  ],
  "evolution_chain": {
    "id": 528,
    "item": null,
    "species": [
      {
        "name": "gimmighoul",
        "order": 976,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gholdengo",
        "order": 977,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 999,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 80,
    "speed": 160,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
